import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const MENSTRUAL_FIELD_LABELS = {
  lmp: 'LMP',
  menarche: 'Menarche',
  cycleLength: 'Cycle Length',
  duration: 'Duration',
  flow: 'Flow',
  pain: 'Pain',
  other: 'Others',
};

function MenstrualHistoryDisplay({ menstrualHistory }) {
  const theme = useTheme();
  const primaryColor = theme.palette.logo?.main || '#00798E';
  const textColor = theme.palette.text?.main || '#344767';
  const secondaryColor = theme.palette.secondary?.main || '#7b809a';

  if (!menstrualHistory || menstrualHistory.length === 0) {
    return null;
  }

  const latestRecord = menstrualHistory[0];
  const hasData = Object.values(latestRecord).some(v => v && v !== '');

  if (!hasData) return null;

  return (
    <Box>
      <Grid container spacing={2}>
        {Object.entries(MENSTRUAL_FIELD_LABELS).map(([key, label]) => {
          const value = latestRecord[key];
          if (!value || value === '') return null;
          return (
            <Grid item xs={6} sm={4} md={3} key={key}>
              <Box sx={{ backgroundColor: '#fafbfc', p: 1.2, borderRadius: 1, border: '1px solid #f0f0f0' }}>
                <Typography variant="caption" sx={{ color: secondaryColor, fontWeight: 600, fontSize: '0.7rem', textTransform: 'uppercase', display: 'block', mb: 0.3 }}>
                  {label}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600, color: textColor, fontSize: '0.85rem' }}>
                  {value}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

MenstrualHistoryDisplay.propTypes = {
  menstrualHistory: PropTypes.arrayOf(
    PropTypes.shape({
      lmp: PropTypes.string,
      menarche: PropTypes.string,
      cycleLength: PropTypes.string,
      duration: PropTypes.string,
      flow: PropTypes.string,
      pain: PropTypes.string,
      other: PropTypes.string,
    })
  ),
};

export default MenstrualHistoryDisplay;
